<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Counters" pageTitle="Counters" />
            <CountersContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import CountersContent from '../Counters/CountersContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'CountersPage',
    components: {
        MainHeader,
        PageTitle,
        CountersContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>